import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../Atoms/Button';
import Card, { CardAppearance } from '../../Atoms/Card';
import Picture from '../../Atoms/Picture';

import { propTypesGatsbyImage } from '../../../shared/constants/Proptypes';
import * as S from './PromoCard.styles';

export const PromoCard = ({
  title,
  label,
  linkUrl,
  linkTarget,
  illustrationAlt,
  illustrationProps,
}) => {
  if (!illustrationProps?.imageUrl || !title || !label || !linkUrl) {
    return null;
  }

  return (
    <S.PromoCard>
      <Card appearance={CardAppearance.VERTICAL}>
        <S.LinkBox href={linkUrl}>
          <Picture
            altText={illustrationAlt || 'promo-picture'}
            radius='15px'
            width='100%'
            {...illustrationProps}
          />
          <S.Title>{title}</S.Title>
          <Button link={linkUrl} target={linkTarget}>
            {label}
          </Button>
        </S.LinkBox>
      </Card>
    </S.PromoCard>
  );
};

PromoCard.propTypes = {
  /**
   * Alternative text of the illustration.
   */
  illustrationAlt: PropTypes.string,
  /**
   * Illustration.
   */
  illustrationProps: PropTypes.shape({
    imageObject: PropTypes.shape(propTypesGatsbyImage),
    imageUrl: PropTypes.string,
  }).isRequired,
  /**
   * Label on the CTA of the card.
   */
  label: PropTypes.string.isRequired,
  /**
   * Target of the url.
   */
  linkTarget: PropTypes.string,
  /**
   * Url on the CTA of the card.
   */
  linkUrl: PropTypes.string.isRequired,
  /**
   * Title of the card.
   */
  title: PropTypes.string.isRequired,
};

PromoCard.defaultProps = {
  illustrationAlt: 'promo-card-picture',
};
